import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const LoyaltyIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z"
            fill="#222"
          />
          <path
            d="M6.5 8C7.32843 8 8 7.32843 8 6.5 8 5.67157 7.32843 5 6.5 5 5.67157 5 5 5.67157 5 6.5 5 7.32843 5.67157 8 6.5 8zM8.89999 12.55C8.89999 13.12 9.12999 13.62 9.49999 14L13 17.5 16.5 14C16.87 13.63 17.1 13.11 17.1 12.55 17.1 11.42 16.18 10.5 15.05 10.5 14.48 10.5 13.97 10.73 13.6 11.1L13 11.7 12.4 11.11C12.03 10.73 11.51 10.5 10.95 10.5 9.81999 10.5 8.89999 11.42 8.89999 12.55z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
